import { ParsedQuery } from 'query-string';
import {
  from_filter_query_for_groups,
  GroupFieldsMeta,
  ParsedFilterQuery,
  to_filter_query_for_groups,
  to_parsed_filter_query_for_groups,
} from 'components/pages/filter-transformer';
import { FilterGroupType } from 'components/pages/types';
import { Transformer as SearchTransformer } from 'hooks/use-search';
import { ResourceManagementFilter } from '../types';
import {
  availabilityFilterTransformer,
  from_availability_filter_query,
  ParsedAvailabilityFilterQuery,
  to_parsed_availability_filter_query,
} from './availability-filter-transformer';

export type ParsedResourceManagementFilterQuery = ParsedFilterQuery &
  ParsedAvailabilityFilterQuery;

export const to_parsed_resource_management_filter_query = (
  query: ParsedQuery,
): Partial<ParsedResourceManagementFilterQuery> => ({
  ...to_parsed_filter_query_for_groups(query),
  ...to_parsed_availability_filter_query(query),
});
export const from_resource_management_filter_query =
  (lookup: GroupFieldsMeta, defaultGroup: FilterGroupType) =>
  (
    query: Partial<ParsedResourceManagementFilterQuery>,
  ): ResourceManagementFilter => ({
    filter: from_filter_query_for_groups(lookup, defaultGroup)(query),
    availabilityFilter: from_availability_filter_query(query),
  });

export const to_resource_management_filter_query = ({
  filter,
  availabilityFilter,
}: ResourceManagementFilter): ParsedResourceManagementFilterQuery => ({
  ...to_filter_query_for_groups(filter),
  ...(availabilityFilterTransformer.to(
    availabilityFilter,
  ) as ParsedAvailabilityFilterQuery),
});

export const getResourceManagementFilterTransformer = (
  lookup: GroupFieldsMeta,
  defaultGroup: FilterGroupType,
): SearchTransformer<ResourceManagementFilter> => ({
  from: (parsed) =>
    from_resource_management_filter_query(
      lookup,
      defaultGroup,
    )(to_parsed_resource_management_filter_query(parsed)),
  to: to_resource_management_filter_query,
});
